import { render } from "./input-size.vue?vue&type=template&id=9f8b9810"
import script from "./input-size.vue?vue&type=script&lang=js"
export * from "./input-size.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__